import { defineComponent } from "vue";
import LinkButton from "./component-library3.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "variant-selector-basic",
  props: {
    isAccessible: { type: Boolean, default: true },
    displayName: { default: void 0 },
    variants: { default: () => [] }
  },
  emits: ["select-variant"],
  setup(__props) {
    return { __sfc: true, LinkButton };
  }
});
export {
  _sfc_main as default
};
